import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { MainDataService } from 'app/services/main-data.service';
import { LineDirection } from 'app/services/map-shared.service';
import { CenterlineSide, ResoCenterCol } from 'app/services/resolution-center.service';
import { RCRecordItemExt as RCRecordItemRAOExt} from '../resolution-rao/resolution-rao.component';

@Component({
  selector: 'app-rc-road-direction',
  templateUrl: './rc-road-direction.component.html',
  styleUrls: ['./rc-road-direction.component.css', '../resolution-inspector/resolution-inspector.component.css']
})
export class RcRoadDirectionComponent implements OnInit {
	@Input() centerlineDirection: LineDirection;
	@Input() fromAddrLeftCol: ResoCenterCol;
	@Input() toAddrLeftCol: ResoCenterCol;
	@Input() fromAddrRightCol: ResoCenterCol;
	@Input() toAddrRightCol: ResoCenterCol;
	@Input() centerline: RCRecordItemRAOExt;
	@Input() isCurrentRoad: boolean;
	@Input() connectedEnd: 'first' | 'second' | 'both';
	@Input() centerlineIdx: number; // first centerline or second in the array
	@Input() isRelativePosConsistentWithDirection: boolean;
	@Input() isLinesDirectionSame: boolean;

	// isFromLeftError;
	// isToLeftError;
	// isFromRightError;
	// isToRightError;

	@Output() edit: EventEmitter<any> = new EventEmitter();
	@Output() jointChange: EventEmitter<{
		side: CenterlineSide,
		idx: number;
	}> = new EventEmitter();
	@Output() attach: EventEmitter<{
		side: CenterlineSide,
		id;
	}> = new EventEmitter();
	@Output() flipFromTo: EventEmitter<{
		side: CenterlineSide,
		id;
	}> = new EventEmitter();

	attrFlipIconPosition: 'upper' | 'lower' | 'left' | 'right';

	constructor(
		private activityService: ActivityService,
		private flipRoadService: FlipRoadService,
		private mainDataService: MainDataService
	) { }

	onEdit(e) {
		this.edit.emit(e);
	}
	clickJointChange(side: CenterlineSide) {
		this.jointChange.emit({
			side: side,
			idx: this.centerlineIdx
		});
	}
	clickAttach(side: CenterlineSide) {
		this.attach.emit({
			side: side,
			id: this.centerline.id
		});
	}
	clickFlipFromTo(side: CenterlineSide) {
		this.flipFromTo.emit({
			side: side,
			id: this.centerline.id
		});
	}

	async flipRoadAttrs() {
		const rsp = await this.flipRoadService.flipRoadAttrs(this.centerline.props);
		if (rsp && !rsp.cancel && rsp.cols && rsp.cols.length) {
			this.flipRoadService.flipRoadSubject.next({
				id: this.centerline.id,
				transposeCols: rsp.cols
			});
		}
	}
	flipRoadGeom() {
		this.flipRoadService.flipRoadSubject.next({
			id: this.centerline.id,
			geom: true
		});
	}
	private calcAttrFlipIconPosition() {
		// Two lines' relavtive position is horizontal (two line in same row)
		if (this.centerline.relativePosition === 'left' || this.centerline.relativePosition === 'right') {
			// The line itself is horizontal
			if (this.centerline.horizontalVertical === 'hori') {
				this.attrFlipIconPosition = this.centerlineIdx === 0 ? 'left' : 'right';
			}
			// The line itself is vertical
			else {
				this.attrFlipIconPosition = this.centerline.direction === 'N' ? 'upper' : 'lower';
			}
		}
		// Two lines in same column
		else {
			// The line itself is vertical
			if (this.centerline.horizontalVertical === 'vert') {
				this.attrFlipIconPosition = this.centerlineIdx === 0 ? 'upper' : 'lower';
			}
			// The line itself is horizontal
			else {
				this.attrFlipIconPosition = this.centerline.direction === 'W' ? 'left' : 'right';
			}
		}
	}
	ngOnInit() {
		// Calculate attrFlipIcon position
		this.calcAttrFlipIconPosition();
	}

}
